import { createStore } from "vuex";
import login from "./modules/login";
import wallet from "./modules/wallet";
import dashboard from "./modules/dashboard";
import products from "./modules/products";
import factor from "./modules/factor";
import request from "./modules/request";
import employees from "./modules/employees";
import defective from "./modules/defective";
import axiosInstance from "@/composables/axios-instance";
import { toast } from "vue3-toastify";

export default createStore({
  state: {
    isDark: false,
    inventoryList: [],
    inventory: '',
    loading: true
  },
  getters: {
    getDarkMode(state){
      return state.isDark;
    },
    getInventory(state){
      return state.inventory;
    },
    getInventoryList(state){
      return state.inventoryList;
    },
    getLoading(state){
      return state.loading;
    }
  },
  mutations: {
    setDarkMode(state, bool){
      state.isDark = bool;
    },
    setInventory(state, inventory){
      state.inventory = inventory;
    },
    setInventoryList(state, list){
      state.inventoryList = list.reverse();
      state.inventory = state.inventoryList[0].id;
    },
    setLoading(state, loading){
      state.loading = loading;
    }
  },
  actions: {
    setDarkModeToLocaleStorage({commit}, bool){
      localStorage.setItem("dark-mode",bool);
      commit("setDarkMode", bool);
    },
    getInventoryListFromApi({commit}){
      return axiosInstance.get("/inventory/list/").then(response =>{
        commit("setInventoryList", response.data);
      }).catch(error =>{
        toast.error("لیست انبارها دریافت نشد");
        console.error(error);
      })
    }
  },
  modules: {
    login,
    wallet,
    dashboard,
    products,
    factor,
    request,
    employees,
    defective,
  },
});
